import { Slider } from '../Slider';

interface PeakPercentageSliderProps {
  minimum: number;
  maximum: number;
  isDisabled: boolean;
  value: number;
  onChange: (event: Event, value: number | number[]) => void;
}

const PeakPercentageSlider = ({
  minimum,
  maximum,
  isDisabled,
  value,
  onChange
}: PeakPercentageSliderProps) => {
  return (
    <Slider
      minimumValue={minimum}
      maximumValue={maximum}
      isDisabled={isDisabled}
      showMinimumLabel={true}
      value={value}
      onChange={onChange}
    />
  );
};

export default PeakPercentageSlider;
